import React from "react";

function Footer() {
    return <footer>
      <p>To learn more, check out the <a href="https://github.com/bbatjargal/histogram-chart" target="blank">Histogram Component</a>.</p>
    </footer>
}

export default Footer